import React from "react";
import Navigation from "../Navigation";
import logo from "../../images/stavby-sever-sklo.png";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

interface HeaderProps {
}

const Header:React.FC<HeaderProps> = ({}) => {
    return (
    <header className="mainNav">
      <div className="flex items-center">
        <Link to="https://stavbysever.cz">
          <div style={{width: 30, height: 30, borderRadius:50}}>
            <StaticImage 
            src="../../images/home.svg" 
            height={24} 
            width={24} 
            role="img"
            alt="ikona domů" />
          </div>
        </Link>
        <Link to="/">
          <div role="img">
            <img src={logo} height="40px" width="150px" alt="stavby sever logo" />
          </div>
        </Link>
      </div>
        <Navigation items={[{
          uri:"/#onas",
          label:"O nás"
        },{
          uri:"/#portfolio",
          label: "Služby"
        },{
          uri:"/#contact",
          label:"Kontakt"
        },{
          uri:"/#reference",
          label:"Reference"
        }]} />
    </header>
    )
}

export default Header;